import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService 
{
  constructor(private afAuth: AngularFireAuth) 
  {
  }

  public isLoggedIn()
  {
    if(this.afAuth.user != null)
      return this.afAuth.user.toPromise();
    else
      return null;
  }

  loginViaGoogle()
  {
    return this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  logout() 
  {
    return this.afAuth.signOut()
  }
}